require('./aggregatorStatus.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

// @components
const { OKButton } = require('components/commons/OKButton/OKButton');
const { AggregatorSecondKeyAuthModal } = require('components/aggregator/aggregatorSecondKeyAuthModal/aggregatorSecondKeyAuthModal')
import { ConfirmModal } from 'components/commons/confirmModal/confirmModal'

// @actions
import { removeEntity } from 'actions/aggregator/aggregatorData'

// @utilities
const { FormattedText, formatText } = require('core/i18n').i18n;
import Storage from 'utilities/storage';
import {
    recordLink,
    PROC_AGGREGATOR,
    PROC_INSERT_OTP,
    PROC_NOT_RECEIVED_OTP,
    PROC_EXPIRED_OTP_REQUEST_OTP,
    PROC_EXPIRED_OTP_REMOVE_ENTITY,
    PROC_ERROR_CONNECTION_REQUEST_OTP,
    PROC_ERROR_CONNECTION_REMOVE_ENTITY,
    PROC_OTP_MODAL_REQUEST_OTP,
} from 'utilities/tagging';

// @constants
import { STEP } from 'constants/aggregator/consentViewType';
import { SELECTED_BANK } from 'constants/aggregator/localStorageKeys';
import {
    MESSAGES_STATUSES,
    PENDING,
    SECOND_FACTOR_AUTHENTICATION,
    BAD_SECOND_FACTOR_AUTHENTICATION,
    EXPIRED_SECOND_FACTOR_AUTHENTICATION,
    OK,
    REVIEW,
    BAD_CREDENTIALS,
    PSD2_SESSION_EXPIRED,
    PSD2_CONSENT_INVALID,
    PENDING_SCRAPING_CREDENTIALS,
} from 'constants/aggregator/statuses'
import { RENEW_TOKEN, RENEW_CONSENT } from 'constants/aggregator/psd2DecoupledFlowType';
import { PSD2_FLOW_TYPE } from 'constants/aggregator/localStorageKeys';
const SECOND_KEY_STATUSES = [SECOND_FACTOR_AUTHENTICATION, BAD_SECOND_FACTOR_AUTHENTICATION, EXPIRED_SECOND_FACTOR_AUTHENTICATION]
const TRANSLATION_KEY_PREFIX = 'aggregatorManageEntities';

class AggregatorStatusClass extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            isOpenKeyModal: false,
            isOpenRemoveModal: false
        }
    }

    getPrimaryButtonAction = (statusContent) => {
        const { userBankId, bankCode, bankStatus, bankName, bankLogo, history } = this.props;

        switch (bankStatus) {
            case SECOND_FACTOR_AUTHENTICATION:
                recordLink(PROC_AGGREGATOR, PROC_INSERT_OTP)
                history.push(`${statusContent.URL}${userBankId}`)
                break;
            case BAD_SECOND_FACTOR_AUTHENTICATION:
                recordLink(PROC_AGGREGATOR, PROC_ERROR_CONNECTION_REQUEST_OTP)
                this.handleShowKeyModal()
                break;
            case EXPIRED_SECOND_FACTOR_AUTHENTICATION:
                recordLink(PROC_AGGREGATOR, PROC_EXPIRED_OTP_REQUEST_OTP)
                this.handleShowKeyModal()
                break;
            case BAD_CREDENTIALS:
                history.push(`${statusContent.URL}${userBankId}`)
                break;
            case PSD2_SESSION_EXPIRED:
                Storage.localStorage.set(PSD2_FLOW_TYPE, RENEW_TOKEN)
                history.push(`${statusContent.URL}${bankCode}`)
                break;
            case PSD2_CONSENT_INVALID:
                Storage.localStorage.set(SELECTED_BANK, {
                    bankName: bankName,
                    bankLogo: bankLogo,
                    userBankId,
                })
                Storage.localStorage.set(PSD2_FLOW_TYPE, RENEW_CONSENT)
                history.push(`/myprofile/global/entities/consent/${STEP}`)
                break;
            case PENDING_SCRAPING_CREDENTIALS:
                history.push(`${statusContent.URL}${userBankId}`)
                break;
        }
    }

    getSecondaryButtonAction = () => {
        const { bankStatus } = this.props;

        switch (bankStatus) {
            case SECOND_FACTOR_AUTHENTICATION:
                recordLink(PROC_AGGREGATOR, PROC_NOT_RECEIVED_OTP)
                this.handleShowKeyModal()
                break;
            case BAD_SECOND_FACTOR_AUTHENTICATION:
                recordLink(PROC_AGGREGATOR, PROC_ERROR_CONNECTION_REMOVE_ENTITY)
                this.showRemoveEntityModal(true)
                break;
            case EXPIRED_SECOND_FACTOR_AUTHENTICATION:
                recordLink(PROC_AGGREGATOR, PROC_EXPIRED_OTP_REMOVE_ENTITY)
                this.showRemoveEntityModal(true)
        }
    }

    showRemoveEntityModal = isOpen => {
        this.setState({ isOpenRemoveModal: isOpen })
    }

    requestSendingNewOtp = () => {
        const { getSecondFactorAuth, userBankId } = this.props;

        recordLink(PROC_AGGREGATOR, PROC_OTP_MODAL_REQUEST_OTP);
        getSecondFactorAuth(userBankId)
    }

    handleShowKeyModal = () => {
        this.setState({ isOpenKeyModal: true })
    }

    handleHideKeyModal = () => {
        this.setState({ isOpenKeyModal: false })
    }

    handleOnAcceptRemoveEntity = () => {
        const { removeEntity, userBankId } = this.props;

        removeEntity(userBankId)
        this.showRemoveEntityModal(false)
    }

    handleOnCancelRemoveEntity = () => {
        this.showRemoveEntityModal(false)
    }

    buildContent = () => {
        const { isOpenKeyModal, isOpenRemoveModal } = this.state;
        const { bankName, userBankId, bankStatus } = this.props;
        const descriptionInjectedStrings = bankStatus === REVIEW ? [bankName, bankName] : [bankName];
        const statusContent = MESSAGES_STATUSES.filter((content) => content.NAME === bankStatus)[0] || {};

        if (bankStatus !== OK) {
            return (
                <React.Fragment>
                    <div className="aggregator-status">
                        {bankStatus === PENDING &&
                            <div className="aggregator-status__dots-container">
                                <div className="aggregator-status__dots-container__dot" />
                                <div className="aggregator-status__dots-container__dot" />
                                <div className="aggregator-status__dots-container__dot" />
                            </div>
                        }
                        <h3 className="aggregator-status__title">
                            <FormattedText value={statusContent.TITLE} injectedStrings={[bankName]} />
                        </h3>
                        <p className="aggregator-status__sub-title">
                            <FormattedText value={statusContent.DESCRIPTION} injectedStrings={descriptionInjectedStrings} />
                        </p>
                        <div className="aggregator-status__button-container">
                            {userBankId && statusContent.TEXT_PRIMARY_BUTTON && <OKButton onClick={
                                () => this.getPrimaryButtonAction(statusContent)
                            }>
                                <FormattedText value={statusContent.TEXT_PRIMARY_BUTTON} />
                            </OKButton>}
                            {SECOND_KEY_STATUSES.includes(bankStatus) && statusContent.TEXT_SECOND_BUTTON && <OKButton onClick={() => this.getSecondaryButtonAction()} modifier="link-complementary">
                                <FormattedText value={statusContent.TEXT_SECOND_BUTTON} />
                            </OKButton>}
                        </div>
                    </div>
                    <AggregatorSecondKeyAuthModal
                        showKeyModal={isOpenKeyModal}
                        requestSendingNewOtp={this.requestSendingNewOtp}
                        onCloseCallback={this.handleHideKeyModal}
                    />
                    <ConfirmModal
                        open={isOpenRemoveModal}
                        title={formatText(`${TRANSLATION_KEY_PREFIX}-modalTitle`)}
                        text={formatText(`${TRANSLATION_KEY_PREFIX}-modalText`)}
                        onAccept={this.handleOnAcceptRemoveEntity}
                        onCancel={this.handleOnCancelRemoveEntity}
                    />
                </React.Fragment>
            )
        } else {
            return null;
        }
    }

    render() {
        return (
            this.buildContent()
        )
    }
}

AggregatorStatusClass.propTypes = {
    bankName: PropTypes.string,
    bankCode: PropTypes.string,
    bankLogo: PropTypes.string,
    getSecondFactorAuth: PropTypes.func,
    userBankId: PropTypes.string,
    bankStatus: PropTypes.string,
    removeEntity: PropTypes.func,
    history: PropTypes.object.isRequired,
}

const AggregatorStatus = connect(() => { }, {
    removeEntity,
})(withRouter(AggregatorStatusClass))

module.exports.constructor = AggregatorStatus;
module.exports.AggregatorStatus = AggregatorStatus
